module.exports = __webpack_public_path__ + "static/media/playlist-large18.c2679b2c.svg";